/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsDeleteContent: {
  name: 'delete-content';
  data: string;
} = {
  name: 'delete-content',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 4.586A2 2 0 0 1 10.414 4H20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-9.586A2 2 0 0 1 9 19.414l-6-6a2 2 0 0 1 0-2.828l6-6ZM20 6h-9.586l-6 6 6 6H20V6Zm-3.293 3.293a1 1 0 0 1 0 1.414L15.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L14 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L12.586 12l-1.293-1.293a1 1 0 1 1 1.414-1.414L14 10.586l1.293-1.293a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
